export default "__VITE_ASSET__CpsoDTk9__"